<section class="page-offset section-pad">
  <div class="container">
    <div class="d-flex flex-column flex-md-row justify-content-between gap-3 mb-4">
      <div>
        <h1 class="fw-bold">{{ i18n.t('files.title') }}</h1>
        <p class="text-secondary">{{ i18n.t('files.subtitle') }}</p>
      </div>
      <button class="btn btn-primary align-self-md-start" type="button" (click)="openNewFileModal()" [disabled]="files.isBusy('add')">
        @if (files.isBusy('add')) { <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span> } @else { <i class="bi bi-plus-lg me-2" aria-hidden="true"></i> }
        {{ i18n.t('files.addFile') }}
      </button>
    </div>
    @if (files.error()) { <div class="alert alert-danger">{{ files.error() }}</div> }
    @if (files.isLoading()) {
      <div class="soft-card bg-white p-5" aria-live="polite">
        <app-loading-spinner [label]="i18n.t('common.loadingPage')"></app-loading-spinner>
      </div>
    } @else {
    <div class="row g-4">
      @for (file of files.files(); track file.id) {
        <div class="col-lg-4">
          <div class="soft-card bg-white p-4 h-100">
            <select class="form-select mb-2" [(ngModel)]="file.type">
              @for (type of fileTypes; track type) {
                <option [ngValue]="type">{{ fileTypeLabel(type) }}</option>
              }
            </select>
            <input class="form-control mb-2" [(ngModel)]="file.title">
            <textarea class="form-control mb-2" rows="3" [(ngModel)]="file.note"></textarea>
            <span class="badge text-bg-success me-2">{{ fileStatusLabel(file.status) }}</span>
            <small class="text-secondary">{{ updatedAtLabel(file.updatedAt) }}</small>
            @if (file.originalFilename) { <div class="small text-secondary mt-2 text-truncate">{{ file.originalFilename }}</div> }
            <div class="d-flex justify-content-end gap-2 mt-3">
              <label class="btn btn-sm btn-outline-secondary mb-0" [class.disabled]="files.isBusy('upload', file.id)" [attr.aria-label]="i18n.t('files.replaceFile')" [attr.title]="i18n.t('files.replaceFile')">
                @if (files.isBusy('upload', file.id)) { <span class="spinner-border spinner-border-sm" aria-hidden="true"></span> } @else { <i class="bi bi-upload" aria-hidden="true"></i> }
                <input class="visually-hidden" type="file" (change)="onReplacementSelected(file, $event)" [disabled]="files.isBusy('upload', file.id)">
              </label>
              <button class="btn btn-sm btn-outline-secondary" type="button" (click)="files.preview(file)" [disabled]="files.isBusy('preview', file.id) || file.isLocalOnly" [attr.aria-label]="i18n.t('common.preview')" [attr.title]="i18n.t('common.preview')">
                @if (files.isBusy('preview', file.id)) { <span class="spinner-border spinner-border-sm" aria-hidden="true"></span> } @else { <i class="bi bi-eye" aria-hidden="true"></i> }
              </button>
              <button class="btn btn-sm btn-outline-secondary" type="button" (click)="files.download(file)" [disabled]="files.isBusy('download', file.id) || file.isLocalOnly" [attr.aria-label]="i18n.t('common.download')" [attr.title]="i18n.t('common.download')">
                @if (files.isBusy('download', file.id)) { <span class="spinner-border spinner-border-sm" aria-hidden="true"></span> } @else { <i class="bi bi-download" aria-hidden="true"></i> }
              </button>
              <button class="btn btn-sm btn-outline-primary" type="button" (click)="files.save(file)" [disabled]="files.isBusy('save', file.id)" [attr.aria-label]="i18n.t('common.save')" [attr.title]="i18n.t('common.save')">
                @if (files.isBusy('save', file.id)) { <span class="spinner-border spinner-border-sm" aria-hidden="true"></span> } @else { <i class="bi bi-floppy" aria-hidden="true"></i> }
              </button>
              <button class="btn btn-sm btn-outline-danger" type="button" (click)="files.remove(file.id)" [disabled]="files.isBusy('delete', file.id)" [attr.aria-label]="i18n.t('common.delete')" [attr.title]="i18n.t('common.delete')">
                @if (files.isBusy('delete', file.id)) { <span class="spinner-border spinner-border-sm" aria-hidden="true"></span> } @else { <i class="bi bi-trash" aria-hidden="true"></i> }
              </button>
            </div>
          </div>
        </div>
      } @empty {
        @if (!files.isLoading()) {
          <div class="col-12">
            <div class="soft-card bg-white p-5 text-center files-empty-state">
              <i class="bi bi-folder-plus empty-state-icon" aria-hidden="true"></i>
              <h2 class="h4 mt-3 mb-2">{{ i18n.t('files.empty.title') }}</h2>
              <p class="text-secondary mb-4">{{ i18n.t('files.empty.description') }}</p>
              <button class="btn btn-primary" type="button" (click)="openNewFileModal()" [disabled]="files.isBusy('add')">
                @if (files.isBusy('add')) { <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span> } @else { <i class="bi bi-plus-lg me-2" aria-hidden="true"></i> }
                {{ i18n.t('files.empty.action') }}
              </button>
            </div>
          </div>
        }
      }
    </div>
    }
  </div>
</section>

@if (modal.isOpen) {
  <div class="modal-backdrop fade show"></div>
  <div class="modal fade show d-block" tabindex="-1" role="dialog" aria-modal="true">
    <div class="modal-dialog modal-dialog-centered">
      <form class="modal-content" (ngSubmit)="submitNewFile()" [attr.aria-busy]="isSubmitting">
        <div class="modal-header">
          <h2 class="modal-title fs-5">{{ i18n.t('files.newFile.title') }}</h2>
          <button class="btn-close" type="button" (click)="closeNewFileModal()" [disabled]="isSubmitting" [attr.aria-label]="i18n.t('common.cancel')"></button>
        </div>
        <div class="modal-body">
          <p class="required-fields-notice text-secondary small bg-light rounded-3 p-3 mb-3">{{ i18n.t('common.requiredFieldsNotice') }}</p>
          <label class="form-label" for="new-file-type">{{ i18n.t('files.newFile.type') }}<span class="required-star" aria-hidden="true">*</span></label>
          <select id="new-file-type" class="form-select mb-3" name="type" [(ngModel)]="modal.type" [disabled]="isSubmitting" [attr.disabled]="isSubmitting ? '' : null" required>
            @for (type of fileTypes; track type) { <option [ngValue]="type">{{ fileTypeLabel(type) }}</option> }
          </select>

          <label class="form-label" for="new-file-title">{{ i18n.t('files.newFile.name') }}<span class="required-star" aria-hidden="true">*</span></label>
          <input id="new-file-title" class="form-control mb-3" name="title" [(ngModel)]="modal.title" [disabled]="isSubmitting" [attr.disabled]="isSubmitting ? '' : null" required>

          <label class="form-label" for="new-file-note">{{ i18n.t('files.newFile.note') }}</label>
          <textarea id="new-file-note" class="form-control mb-3" rows="3" name="note" [(ngModel)]="modal.note" [disabled]="isSubmitting" [attr.disabled]="isSubmitting ? '' : null"></textarea>

          <label class="form-label" for="new-file-local">{{ i18n.t('files.newFile.localFile') }}<span class="required-star" aria-hidden="true">*</span></label>
          <input id="new-file-local" class="form-control" type="file" (change)="onLocalFileSelected($event)" [disabled]="isSubmitting" [attr.disabled]="isSubmitting ? '' : null" required>
          <div class="form-text">{{ i18n.t('files.newFile.securityHelp') }}</div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-outline-secondary" type="button" (click)="closeNewFileModal()" [disabled]="isSubmitting">{{ i18n.t('common.cancel') }}</button>
          <button class="btn btn-primary" type="submit" [disabled]="isSubmitting || !modal.file || !modal.title.trim()" [attr.aria-busy]="isSubmitting">
            @if (isSubmitting) { <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span> }
            {{ i18n.t('files.newFile.upload') }}
          </button>
        </div>
      </form>
    </div>
  </div>
}

@if (files.previewState(); as preview) {
  <div class="modal-backdrop fade show" (click)="files.closePreview()"></div>
  <div class="modal fade show d-block file-preview-modal" tabindex="-1" role="dialog" aria-modal="true" aria-labelledby="filePreviewTitle">
    <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <div>
            <h2 id="filePreviewTitle" class="modal-title fs-5">{{ i18n.t('files.preview.title') }}</h2>
            <p class="text-secondary small mb-0">{{ preview.filename }}</p>
          </div>
          <button class="btn-close" type="button" (click)="files.closePreview()" [attr.aria-label]="i18n.t('files.preview.close')"></button>
        </div>
        <div class="modal-body">
          @if (preview.canEmbed) {
            <embed class="file-preview-embed" [src]="preview.safeUrl" [type]="preview.contentType" [attr.title]="preview.filename">
            <div class="file-preview-fallback alert alert-warning mt-3 mb-0">
              {{ i18n.t('files.preview.browserFallback') }}
            </div>
          } @else {
            <div class="file-preview-unavailable text-center py-5">
              <i class="bi bi-file-earmark-arrow-down display-5 text-secondary" aria-hidden="true"></i>
              <h3 class="h5 mt-3">{{ i18n.t('files.preview.unavailableTitle') }}</h3>
              <p class="text-secondary mb-0">{{ i18n.t('files.preview.unavailableText') }}</p>
            </div>
          }
        </div>
        <div class="modal-footer">
          <button class="btn btn-outline-secondary" type="button" (click)="files.closePreview()">{{ i18n.t('common.cancel') }}</button>
          <button class="btn btn-primary" type="button" (click)="files.downloadPreview()"><i class="bi bi-download me-2" aria-hidden="true"></i>{{ i18n.t('common.download') }}</button>
        </div>
      </div>
    </div>
  </div>
}
